module.exports = __webpack_public_path__ + "static/media/RVN.89cc9cb4.svg";